
const STATUS_TRANSFORMER = {
    'Canceled': 'Failed',
    'New': 'InProgress',
    'Paid': 'InProgress',
    'Submitted': 'InProgress'
};

const STATUS_TRANSFORMER_INVERSE = {
    'Failed': ['Canceled', 'Failed'],
    'InProgress': ['InProgress', 'Submitted']
};

export function transformStatus(status: string): string {
    return STATUS_TRANSFORMER[status] || status;
}

export function transformStatusInverse(status: string): string[] {
    return STATUS_TRANSFORMER_INVERSE[status] || [status];
}